import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { LeanBrandTileRendererBase } from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/__internal__/LeanBrandTileRendererBase";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { useObservable } from "@faire/web--source/ui/hooks/useObservable";
import * as React from "react";
import { useMemo } from "react";
export var LeanBrandTileRendererForCarouselBase = function(props) {
    var brandTile = props.brandTile;
    var images = useObservable(function() {
        var _brandTile_images;
        return (_brandTile_images = brandTile === null || brandTile === void 0 ? void 0 : brandTile.images) !== null && _brandTile_images !== void 0 ? _brandTile_images : [];
    });
    var squareImage = useObservable(function() {
        var _brandTile_brand;
        return brandTile === null || brandTile === void 0 ? void 0 : (_brandTile_brand = brandTile.brand) === null || _brandTile_brand === void 0 ? void 0 : _brandTile_brand.squared_image;
    });
    var leanBrandTileForCarousel = useMemo(function() {
        if (!brandTile) {
            return undefined;
        }
        // carousel tile may render image from squared_image instead of images
        var _to_consumable_array_concat_filter = _sliced_to_array(_to_consumable_array(images).concat([
            squareImage
        ]).filter(isNotUndefined), 1), firstImage = _to_consumable_array_concat_filter[0];
        // TODO(Jude): report error if firstImage does not exist which can be an adapter bug
        return _object_spread_props(_object_spread({}, brandTile), {
            images: firstImage ? [
                firstImage
            ] : []
        });
    }, [
        brandTile,
        images,
        squareImage
    ]);
    return /*#__PURE__*/ _jsx(LeanBrandTileRendererBase, _object_spread_props(_object_spread({}, props), {
        brandTile: leanBrandTileForCarousel
    }));
};
